<template>
  <div class="mt-16 bg-white bg-opacity-60 min-h-screen">
    <div class="flex items-center justify-start bg-beige-academy-300 w-full py-2
      text-white text-left">
      <div class="text-base md:text-lg w-full px-8 font-sans-serif
      flex">
        <router-link class="pr-1" to="/teacher-dashboard/classrooms">
          {{ $t('lesson.back') }}
        </router-link>
      </div>
    </div>

    <div class="mx-auto p-0 md:p-10 my-10 w-11/12"
      v-if="classroom">
      <div class="flex flex-col bg-white py-6 px-4 lg:px-20 rounded-none md:rounded-2xl
      shadow-lg overflow-y-scroll">
        <div class="flex md:flex-row flex-col justify-between">
          <div class="flex flex-col font-sans-serif items-center md:items-start">
            <h2 class="uppercase text-lg lg:text-2xl font-black pb-5 tracking-widest">
              {{$t('lesson.participant')}}</h2>
            <round-photo-and-name :person="classroom.student"
            containerClass="flex items-center"
            textClass="text-base lg:text-xl pl-4 font-light" />
          </div>
          <div class="flex flex-col font-sans-serif items-center md:items-start justify-between">
            <div class="flex items-end pb-5">
              <h2 class="uppercase text-lg lg:text-2xl font-black mr-0 md:mr-10 mt-5 md:mt-0
              tracking-widest">
                Media</h2>
              <!--<button class="flex items-center px-2 py-1 bg-beige-academy-100 rounded text-xs
              transform hover:-translate-y-1">
                <download-icon />
                Download all
              </button>-->
            </div>

            <div class="flex items-center text-base lg:text-lg pb-3"
            v-for="m in media" :key="m.id">
              <a :href="m.url" target="_blank" class="transform hover:-translate-y-1 delay-75
              duration-300 px-3 py-2 rounded-full shadow-lg">
                <!--<download-icon />-->
                <span>{{ m.description }}</span>
              </a>

            </div>
          </div>
        </div>
        <div class="flex flex-col items-start mt-10 font-sans-serif">
          <h2 class="uppercase text-lg lg:text-2xl font-black pb-5 tracking-widest">
            {{$t('lesson.booked')}}</h2>
          <lesson-row
            v-for="lesson in classroom.bookedLessons"
            :key="lesson.booking_id"
            :lesson="lesson"
            :isTeacher="true" />
        </div>
        <div class="flex flex-col items-start mt-16 font-sans-serif">
          <h2 class="uppercase text-lg lg:text-2xl font-black pb-5 tracking-widest">
            {{$t('lesson.past')}}</h2>
          <lesson-row
            v-for="lesson in classroom.pastLessons"
            :key="lesson.booking_id"
            :lesson="lesson"
            :isTeacher="true" />
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import getClassroom from '@/services/ClassroomService';
import { mapGetters } from 'vuex';
import LessonRow from '@/components/teachers/LessonRow.vue';
import axios from 'axios';
import RoundPhotoAndName from '../components/graphics/RoundPhotoAndName.vue';

export default {
  data() {
    return {
      classroom: null,

      media: [],
    };
  },

  components: {
    RoundPhotoAndName,
    LessonRow,

  },

  computed: {
    ...mapGetters({
      user: 'auth/user',
      updatedSlots: 'slots/updatedSlots',
    }),
  },

  watch: {
    updatedSlots() {
      this.getClass();
    },
  },

  created() {
    this.getClass();
  },

  methods: {
    getClass() {
      getClassroom(this.$route.params.slug).then(({ data }) => {
        this.classroom = data;
        this.media = this.classroom.media;
      });
    },

    openFile(media) {
      window.location = media.url;
    },

    download(media) {
      axios({
        url: media.url,
        method: 'GET',
        responseType: 'blob',
      }).then((response) => {
        const fileURL = window.URL.createObjectURL(new Blob([response.data]));
        const fileLink = document.createElement('a');

        fileLink.href = fileURL;
        fileLink.setAttribute('download', media.description);
        document.body.appendChild(fileLink);

        fileLink.click();
      });
    },

  },
};
</script>
